<div class="npc-container">
  <img [src]="imgUrl" [style.object-position]="spriteLocation()" />
</div>
